// Mock data for rooms
export const roomsData = [
  {
    id: 1,
    name: 'Room 1',
    description: 'Spacious room with modern amenities and stunning valley views. Perfect for couples seeking comfort and elegance.',
    image: '/images/room1.jpg',
    
    
  },
  {
    id: 2,
    name: 'Room 2',
    description: 'Wake up to breathtaking mountain vistas. Cozy interiors with a private balcony overlooking nature.',
    image: '/images/room2.jpg',
   
  },
  {
    id: 3,
    name: 'Room 3',
    description: 'Generous space for the whole family. Multiple beds, living area, and spectacular views for a memorable stay.',
    image: '/images/room3.jpg',
    
  },
];

// Mock data for gallery
export const galleryImages = [
  {
    url: '/images/gal1.jpg',
    title: 'Mountain Mornings',
  },
  {
    url: '/images/gal2.jpg',
    title: 'Scenic Views',
  },
  {
    url: '/images/gal3.jpg',
    title: 'Workout facilities',
  },
  {
    url: '/images/gal4.jpeg',
    title: 'traditional style',
  },
  {
    url: '/images/gal5.jpg',
    title: 'Peaceful Evenings',
  },
  {
    url: '/images/gal6.jpeg',
    title: 'Natural Trails',
  },
  {
    url: '/images/gal7.jpg',
    title: 'cozy corners',
  },{
    url: '/images/gal8.jpg',
    title: 'Aesthetics',
  },{
    url: '/images/gal9.jpg',
    title: 'A cute guide',
  },{
    url: '/images/room2.jpeg',
    title: 'cozy interiors',
  },{
    url: '/images/gal10.jpg',
    title: 'beutiful vibes',
  },
  {
    url: '/images/gal12.jpg',
    title: 'scenic view',
  },
  {
    url: '/images/gal13.jpg',
    title: 'natural beauty',
  },
  {
    url: '/images/gal14.jpg',
    title: 'morning',
  },
  {
    url: '/images/gal15.jpeg',
    title: 'warm feelings',
  },
  {
    url: '/images/gal16.jpg',
    title: 'scene',
  },
   {
    url: '/images/gal20.jpeg',
    title: 'scene',
  },
   {
    url: '/images/gal21.jpeg',
    title: 'scene',
  },
  {
    url: '/images/gal22.jpg',
    title: 'Night view',
  },
];

// Mock data for nearby places
export const nearbyPlaces = [
  {
    id: 1,
    name: 'Kasar Devi Temple',
    description:
      'A renowned place filled with spiritual energy and geomagnetic fields, located very close to our homestay.',
    image: '/images/kasar.webp',
    distance: '1.5 km',
    duration: '5 min drive',
    type: 'Spiritual',
  },
  {
    id: 2,
    name: 'Almora Market',
    description:
      'A 200-year-old market established by the kings — a lively place full of local culture and heritage.',
    image: '/images/almoramarket.jpg',
    distance: '6.8 km',
    duration: '20 min drive',
    type: 'Cultural',
  },
  {
    id: 3,
    name: 'Nanda Devi Temple',
    description:
      'The most important temple of the region, dedicated to Mata Nanda Devi — the guardian goddess of Almora.',
    image: '/images/nandadevi.jpg',
    distance: '6.0 km',
    duration: '15 min drive',
    type: 'Spiritual',
  },
  {
    id: 4,
    name: 'Chitai Golu Devta Temple',
    description:
      'A peaceful spiritual escape with a breathtaking view of the valley, dedicated to the God of Justice.',
    image: '/images/chitai.webp',
    distance: '9 km',
    duration: '25 min drive',
    type: 'Spiritual',
  },
  {
    id: 5,
    name: 'Katarmal Sun Temple',
    description:
      'An ancient 9th-century temple built by the Katyuri Kings, dedicated to the Sun God.',
    image: '/images/katarmal.jpg',
    distance: '18 km',
    duration: '40 min drive',
    type: 'Historical',
  },
  {
    id: 6,
    name: 'Binsar Zero Point',
    description:
      'The highest vantage point in Binsar Wildlife Sanctuary offering a panoramic Himalayan view.',
    image: '/images/Binsar.jpg',
    distance: '10.5 km',
    duration: '30 min drive',
    type: 'Nature',
  },
  {
    id: 7,
    name: 'Gairar Golu Devta Temple',
    description:
      'A sacred shrine nestled amidst the Kumaon hills, dedicated to Lord Golu Devta.',
    image: '/images/gairar.jpg',
    distance: '5.5 km',
    duration: '15 min drive',
    type: 'Spiritual',
  },
  {
    id: 8,
    name: 'Simtola Eco Park',
    description:
      'A popular picnic spot offering panoramic views of the misty valleys and green ridges.',
    image: '/images/simtola.jpg',
    distance: '4.0 km',
    duration: '10 min drive',
    type: 'Nature',
  },
  {
    id: 9,
    name: 'Kosi Barrage',
    description:
      'A serene riverside location offering the calm beauty of the Kosi River — less crowded and scenic.',
    image: '/images/kosi barrage.avif',
    distance: '5.7 km',
    duration: '15 min drive',
    type: 'Nature',
  },
  {
    id: 10,
    name: 'Almora Zoo',
    description:
      'A small but scenic zoo surrounded by hills and tall pine trees — perfect for family visits.',
    image: '/images/ntd zoo.jpg',
    distance: '4.7 km',
    duration: '15 min drive',
    type: 'Nature',
  },
];
